export default __webpack_public_path__ + "static/media/smileOne.421b45d0.svg";